class MediaVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    if (!this.video) {
      return;
    }

    this.isMobile = window.matchMedia('(max-width: 959px)');

    this.mobilePoster = this.video.dataset.mobilePoster || this.video.dataset.desktopPoster;
    this.desktopPoster = this.video.dataset.desktopPoster || this.video.dataset.mobilePoster;

    if (this.isMobile.matches) {
      this.video.setAttribute('poster', this.mobilePoster);

      return;
    }

    this.video.setAttribute('poster', this.desktopPoster);
  }
}

// Define the custom element
customElements.define('media-video', MediaVideo);
